<div class="modal-header">
	<h4 class="modal-title" id="modal-basic-title">
		<i class="ri-user-fill"></i> {{ userInfo.get("first_name")?.value }} {{ userInfo.get("last_name")?.value }}
		<span *ngIf="userRole === 'SADM'" class="badge bg-dark">Super Admin</span>
		<span *ngIf="userRole === 'ADM'" class="badge bg-danger">Admin</span>
		<span *ngIf="userRole === 'CAL'" class="badge bg-success">Caller</span>
		<span *ngIf="userRole === 'CUS'" class="badge bg-info">Customer</span>
	</h4>
	<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
	<div class="page__menu menu">
		<ul ngbNav #nav="ngbNav" [activeId]="1" (navChange)="onNavChange($event)" class="nav nav-tabs nav-tabs-custom nav-success mb-3">
			<li [ngbNavItem]="1">
				<a ngbNavLink class="menu__link r-link text-underlined">Client data</a>
				<ng-template ngbNavContent>
					<form [formGroup]="userInfo" (ngSubmit)="updateClientUser()">
						<h3>Actions</h3>
						<div class="row">
							<div class="col-4" *ngIf="!isInternalRole">
								<div class="form-check form-switch form-switch-lg" dir="ltr">
									<input type="checkbox" class="form-check-input" id="customSwitchsizelg" formControlName="isMain" (change)="toggleMainUser($event)" />
									<label class="form-check-label" for="customSwitchsizelg">Main Account</label>
								</div>

								<!-- <div align="center" class="form-check form-switch form-switch-danger">
									<input *ngIf="row['isMain'] == 1" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck2" checked (click)="unsetMainAccount(row)" />
									<input *ngIf="row['isMain'] == 0" class="form-check-input" type="checkbox" role="switch" id="SwitchCheck3" (click)="setMainAccount(row)" />
								</div> -->
							</div>
							<div class="col-4" *ngIf="!isInternalRole">
								<div class="form-check form-switch form-switch-lg" dir="ltr">
									<input type="checkbox" class="form-check-input" id="customSwitchsizelg" formControlName="isPremium" (change)="togglePremiumUser($event)" />
									<label class="form-check-label" for="customSwitchsizelg">Premium</label>
								</div>
							</div>
							<div class="col-4">
								<div ngbDropdown class="d-inline-block" style="position: relative; top: -5px">
									<button type="button" class="btn btn-primary" id="dropdownBasic1" ngbDropdownToggle>Email options</button>
									<div ngbDropdownMenu aria-labelledby="dropdownBasic1">
										<button type="button" ngbDropdownItem (click)="resetPassword(); $event.preventDefault()">Reset password</button>
										<button type="button" ngbDropdownItem (click)="testEmail(); $event.preventDefault()">Test email</button>
										<button type="button" ngbDropdownItem (click)="sendLinkToCustomer(); $event.preventDefault()">Welcome email</button>
									</div>
								</div>
							</div>
						</div>

						<hr />

						<div class="row">
							<div class="form-group col-sm-3 mt-2">
								<label for="first_name"><strong>First Name:</strong></label>
								<input formControlName="first_name" type="text" class="form-control" placeholder="First Name" />
							</div>
							<div class="form-group col-sm-3 mt-2">
								<label for="last_name"><strong>Last Name:</strong></label>
								<input formControlName="last_name" type="text" class="form-control" placeholder="Last Name" />
							</div>
							<div class="form-group col-sm-3 mt-2" *ngIf="!isInternalRole">
								<label for="alias"><strong>Alias:</strong></label>
								<input formControlName="alias" type="text" class="form-control" placeholder="Alias" />
							</div>
							<div class="form-group col-sm-3 mt-2" *ngIf="!isInternalRole">
								<label for="middle_name"><strong>Campaign:</strong></label>
								<app-select-search [values]="campaigns" (onSelected)="setAlias($event)" [startValue]="userInfo.get('alias')?.value" [fieldValue]="'alias'"></app-select-search>
							</div>
							<div class="row" *ngIf="userRole !== 'CUS'">
								<div class="form-group col-sm-3 mt-2">
									<label for="ringcentral_ext"><strong>Ring Central Extension:</strong></label>
									<input formControlName="ringcentral_ext" type="number" class="form-control" placeholder="Example: 102" disabled />
								</div>
								<div class="form-group col-sm-3 mt-2">
									<label for="rc_ext_id"><strong>Ring Central Extension ID:</strong></label>
									<input formControlName="rc_ext_id" type="text" class="form-control" disabled />
								</div>
							</div>
						</div>
						<hr />
						<div class="row">
							<div class="form-group col-sm-4 mt-2">
								<label for="primary_email"><strong>Primary Email:</strong></label>
								<div class="input-group">
									<input formControlName="primary_email" type="text" class="form-control" placeholder="Ex. pat@example.com" [readonly]="!editingEmail" />
									<button type="button" class="btn btn-outline-secondary" (click)="toggleEmailEdit()" [disabled]="editingEmail">
										<i class="ri-pencil-fill"></i>
									</button>
								</div>
							</div>
							<div class="form-group col-sm-4 mt-2">
								<label for="email2"><strong>Email 2:</strong></label>
								<input formControlName="email2" type="text" class="form-control" placeholder="Ex. pat@example.com" />
							</div>
							<div class="form-group col-sm-4 mt-2">
								<label for="email3"><strong>Email 3:</strong></label>
								<input formControlName="email3" type="text" class="form-control" placeholder="Ex. pat@example.com" />
							</div>
						</div>

						<div class="row">
							<div class="form-group col-sm-3 mt-2">
								<label for="mobile_phone"><strong>Mobile Phone:</strong></label>
								<input formControlName="mobile_phone" type="number" class="form-control" placeholder="222-555-1234" />
							</div>
							<div class="form-group col-sm-3 mt-2">
								<label for="phone_home"><strong>Phone Home:</strong></label>
								<input formControlName="phone_home" type="number" class="form-control" placeholder="222-555-1234" />
							</div>
							<div class="form-group col-sm-3 mt-2">
								<label for="phone_work"><strong>Phone Work:</strong></label>
								<input formControlName="phone_work" type="number" class="form-control" placeholder="222-555-1234" />
							</div>
							<div class="form-group col-sm-3 mt-2">
								<label for="phone_other"><strong>Phone Other:</strong></label>
								<input formControlName="phone_other" type="number" class="form-control" placeholder="222-555-1234" />
							</div>
						</div>
						<hr />
						<div class="row" *ngIf="!isInternalRole">
							<div class="form-group col-sm-6 mt-2">
								<label for="company_name"><strong>Company Name:</strong></label>
								<input formControlName="company_name" type="text" placeholder="Company Name" class="form-control" />
							</div>
							<div class="form-group col-sm-3 mt-2">
								<label for="account_associated"><strong>Account Associated:</strong></label>
								<select formControlName="account_associated" class="form-control">
									<option value="" disabled selected>Select your Account</option>
									<option *ngFor="let employee of employeeUsers" [value]="employee.login">
										{{ employee.login }}
									</option>
								</select>
							</div>
							<div class="form-group col-sm-3 mt-2">
								<label for="plan"><strong>Plan:</strong></label>
								<select formControlName="plan" class="form-control">
									<option value="essential">Essential Plan</option>
									<option value="basic">Basic Plan</option>
									<option value="growth">Growth Plan</option>
									<option value="premium">Premium Plan</option>
								</select>
							</div>
						</div>
						<div class="row">
							<div class="form-group col-sm-3 mt-2">
								<label for="address"><strong>Address:</strong></label>
								<input formControlName="address" type="text" placeholder="Address" class="form-control" />
							</div>
							<div class="form-group col-sm-3 mt-2">
								<label for="city"><strong>City:</strong></label>
								<input formControlName="city" type="text" placeholder="City" class="form-control" />
							</div>
							<div class="form-group col-sm-3 mt-2">
								<label for="state"><strong>State:</strong></label>
								<select formControlName="state" class="form-control">
									<option *ngFor="let state of states" [value]="state.shortName">{{ state.name }}</option>
								</select>
							</div>
							<div class="form-group col-sm-3 mt-2">
								<label for="zip_code"><strong>Zip Code:</strong></label>
								<input formControlName="zip_code" type="text" placeholder="Zip Code" class="form-control" />
							</div>
						</div>
						<ng-container *ngIf="!isInternalRole">
							<hr />
							<h2>Billing Info</h2>
							<div class="row">
								<div class="col-4">
									<p style="position: relative; top: 15px">
										<span class="startup-fee-label">Startup Paid</span>
										<span *ngIf="userInfo.get('startupFee')?.value" class="startup-fee-icon success"><i class="ri-check-line"></i></span>
										<span *ngIf="!userInfo.get('startupFee')?.value" class="startup-fee-icon danger"><i class="ri-close-line"></i></span>
									</p>
								</div>
								<div class="col-4">
									<label for="zip_code"><strong>Amount:</strong></label>
									<input type="text" formControlName="startupFeeAmount" class="form-control" placeholder="Amount" />
								</div>
								<div class="col-4" align="right">
									<button type="button" class="btn btn-danger" (click)="openDiscountModal(discountModal)" style="position: relative; top: 25px">Discounts</button>
								</div>
							</div>
							<hr />
						</ng-container>
						<!-- <div class="row">
							<div class="col-12" align="right">
								<button class="btn btn-primary mt-2" type="submit">Save</button>
							</div>
						</div> -->
					</form>
				</ng-template>
			</li>

			<li [ngbNavItem]="2" *ngIf="!isInternalRole">
				<a ngbNavLink class="menu__link r-link text-underlined">Contracts</a>
				<ng-template ngbNavContent>
					<div class="row">
						<div class="col-4">
							<h3>
								Contracts <button class="btn btn-primary mt-2" (click)="openContractWizardModal()"><i class="bx bx-plus"></i></button>
							</h3>
						</div>
					</div>
					<div class="row">
						<div id="contractsTable" class="col-12">
							<table class="table table-nowrap">
								<thead>
									<tr>
										<th scope="col">ID</th>
										<th scope="col">Start date</th>
										<th scope="col">End date</th>
										<th scope="col">Contract Type</th>
										<th scope="col">Pricing</th>
										<th scope="col">Action</th>
									</tr>
								</thead>
								<tbody>
									<ng-container *ngFor="let contract of contracts; let i = index">
										<tr>
											<th scope="row">
												<strong>#{{ contract.NumContract }}</strong>
											</th>
											<td>
												<span *ngIf="contract.startDate_ != '0000-00-00 00:00:00'">{{ contract.startDate_ | utcToLocal: "mediumDate" }}</span>
											</td>
											<td>
												<span *ngIf="contract.endDate_ != '0000-00-00 00:00:00'">{{ contract.endDate_ | utcToLocal: "mediumDate" }}</span>
											</td>
											<td>{{ getContractTypeName(contract.contract_type) }}</td>
											<td [ngSwitch]="contract.contract_type">
												<span *ngSwitchCase="1">Lead Cost: {{ contract.costLead | currency: "USD" }}</span>
												<span *ngSwitchCase="2">Reserve Leads: {{ contract.reserve_leads_amount }}</span>
												<span *ngSwitchCase="3">Hour Cost: {{ contract.cost_hour | currency: "USD" }}</span>
												<span *ngSwitchDefault>-</span>
											</td>
											<td>
												<a href="javascript:void(0);" class="link-success" (click)="openDocuments(contract.NumContract, i)">Documents <i class="ri-arrow-right-line align-middle"></i></a>
											</td>
										</tr>
										<tr *ngIf="selectedContractIndex === i && showDocuments">
											<td colspan="6" class="p-0">
												<div class="px-3 py-2 bg-light">
													<app-upload-doc-contract [contract_id]="selectedContract"></app-upload-doc-contract>
												</div>
											</td>
										</tr>
									</ng-container>
								</tbody>
							</table>
						</div>
					</div>
				</ng-template>
			</li>

			<li [ngbNavItem]="3">
				<a ngbNavLink class="menu__link r-link text-underlined">Campaigns</a>
				<ng-template ngbNavContent>
					<h3>Campaigns</h3>

					<table class="table table-nowrap">
						<thead>
							<tr>
								<th scope="col">ID</th>
								<th scope="col">Name</th>
								<th scope="col">Industry</th>
								<th scope="col">Types</th>
								<th scope="col">Status</th>
								<th scope="col" *ngIf="userRole !== 'ADM' && userRole !== 'CAL'">Contract</th>
								<th scope="col">Action</th>
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let campaign of userCampaigns; let i = index">
								<tr>
									<th scope="row">
										<strong>#{{ campaign.id }}</strong>
									</th>
									<td>{{ campaign.name }}</td>
									<td>{{ utils.getIndustryLabel(campaign.industry) }}</td>
									<td [innerHTML]="utils.getApptTypesIcons(campaign.types)"></td>
									<td>
										<span *ngIf="campaign.isActive == 1" class="badge badge-soft-success">Active</span>
										<span *ngIf="campaign.isActive == 0" class="badge badge-soft-danger">Inactive</span>
									</td>
									<td *ngIf="userRole !== 'ADM' && userRole !== 'CAL'">
										<span *ngIf="campaign.contractid == null" class="badge badge-soft-danger pointer" (click)="openModalLinkContracts(userContractsModal, campaign.id)">Link contract</span>
										<span *ngIf="campaign.contractid != null" class="badge badge-soft-success pointer" (click)="openModalLinkContracts(userContractsModal, campaign.id)">Contract #{{ campaign.contractid }}</span>
									</td>
									<td>
										<a href="javascript:void(0);" class="link-success" (click)="goToCampaign(campaign.id)">Open Campaign <i class="ri-arrow-right-line align-middle"></i></a>
									</td>
								</tr>
								<tr *ngIf="selectedContractIndex === i && showDocuments">
									<td colspan="6" class="p-0">
										<div class="px-3 py-2 bg-light">
											<app-upload-doc-contract [contract_id]="selectedContract"></app-upload-doc-contract>
										</div>
									</td>
								</tr>
							</ng-container>
						</tbody>
					</table>
				</ng-template>
			</li>

			<li [ngbNavItem]="4">
				<a ngbNavLink class="menu__link r-link text-underlined" (click)="getLogins()">Login History</a>
				<ng-template ngbNavContent>
					<h3>Login History</h3>

					<div class="row">
						<div class="col-6">
							<label for="">Date Range:</label>
							<app-form-range-date style="width: 100%" [(ngModel)]="dateRange_" (OnSelected)="getLogins()" [position]="'right'" [range_type]="'RANGE_PAST'" [autoApply]="true"></app-form-range-date>
						</div>
						<div class="col-6" align="right">
							<button (click)="exportLoginsToPDF()" type="button" class="btn btn-danger btn-label waves-effect waves-light export-btn">
								<i class="bx bxs-file-pdf label-icon align-middle fs-16 me-2"></i>
								Export
							</button>
						</div>
					</div>
					<hr />
					<div id="loginHistoryTable">
						<ngx-datatable #table class="material" [columnMode]="ColumnMode.force" [scrollbarH]="true" [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [rows]="logins" [limit]="10000">
							<ngx-datatable-column name="#" headerClass="cell-center title-header" cellClass="cell-center" [width]="50">
								<ng-template let-rowIndex="rowIndex" ngx-datatable-cell-template>
									{{ rowIndex + 1 }}
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Date" headerClass="title-header" [width]="200">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div style="text-align: justify">
										{{ row.signin_time ? (row.signin_time | utcToLocal: "MMM d, y, h:mm a") : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="IpV4" headerClass="title-header" [width]="150">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div>
										{{ row.ip && row.ip !== "undefined" ? row.ip : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Country" headerClass="title-header" [width]="100">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div>
										{{ row.country && row.country !== "undefined" ? row.country : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>

							<ngx-datatable-column name="Region" headerClass="title-header" [width]="130">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div>
										{{ row.region && row.region !== "undefined" ? row.region : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="City" headerClass="title-header" [width]="130">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div>
										{{ row.city && row.city !== "undefined" ? row.city : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Zip" headerClass="title-header" [width]="100">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div>
										{{ row.zip && row.zip !== "undefined" ? row.zip : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Latitude" headerClass="title-header" [width]="100">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div>
										{{ row.latitude && row.latitude !== "undefined" ? row.latitude : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Longitude" headerClass="title-header" [width]="100">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div>
										{{ row.longitude && row.longitude !== "undefined" ? row.longitude : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="IpV6" headerClass="title-header" [width]="350">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div>
										{{ row.ipv6 && row.ipv6 !== "undefined" ? row.ipv6 : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>
							<ngx-datatable-column name="Timezone" headerClass="title-header" [width]="200">
								<ng-template let-row="row" ngx-datatable-cell-template>
									<div>
										{{ row.timezone && row.timezone !== "undefined" ? row.timezone : "-" }}
									</div>
								</ng-template>
							</ngx-datatable-column>
						</ngx-datatable>
					</div>
				</ng-template>
			</li>
			<li [ngbNavItem]="5">
				<a ngbNavLink class="menu__link r-link text-underlined">Actions History</a>
				<ng-template ngbNavContent>
					<app-user-actions [user_id]="user_id" [userInfo]="getUserInfoObject()"></app-user-actions>
				</ng-template>
			</li>
			<li [ngbNavItem]="6" *ngIf="userRole !== 'CUS'">
				<a ngbNavLink class="menu__link r-link text-underlined" (click)="getUserPermissions()">Permissions</a>
				<ng-template ngbNavContent>
					<!-- Solo CAL: DB Reset -->
					<div class="row mt-3" *ngIf="userRole === 'CAL'">
						<div class="col-4">
							<div class="card border shadow-none mb-0">
								<div class="card-body p-3 text-center">
									<div class="form-check form-switch form-switch-danger d-flex justify-content-center mb-1">
										<input class="form-check-input" type="checkbox" role="switch" [checked]="isDbReset" (change)="toggleDbReset($event)" />
									</div>
									<label class="fw-medium">DB Reset</label>
									<p class="text-muted mb-0" style="font-size: 11px">DB reset access</p>
								</div>
							</div>
						</div>
					</div>

					<!-- Resto de roles: permisos de vistas -->
					<div class="row mt-3" *ngIf="userRole !== 'CAL'">
						<div class="col-md-4" *ngFor="let column of menuColumns">
							<h6 class="text-muted text-uppercase fw-semibold mb-3">View Permissions</h6>
							<ng-container *ngFor="let item of column">
								<ng-container *ngIf="!item.isTitle && !item.isLayout">
									<!-- Item sin subItems -->
									<div class="mb-3" style="break-inside: avoid" *ngIf="!item.subItems || item.subItems.length === 0">
										<div class="card border shadow-none mb-0">
											<div class="card-body p-3 d-flex justify-content-between align-items-center">
												<div class="d-flex align-items-center">
													<i class="{{ item.icon }} me-2 text-muted"></i>
													<span class="fw-medium">{{ item.label | translate }}</span>
												</div>
												<div class="form-check form-switch mb-0">
													<input class="form-check-input" type="checkbox" role="switch" [checked]="getPermission(item.id)?.isActive == 1" (change)="togglePermission(item, $event)" />
												</div>
											</div>
										</div>
									</div>

									<!-- Item con subItems -->
									<div class="mb-3" style="break-inside: avoid" *ngIf="item.subItems && item.subItems.length > 0">
										<div class="card border shadow-none mb-0">
											<div class="card-header p-2 bg-light d-flex align-items-center">
												<i class="{{ item.icon }} me-2 text-muted"></i>
												<span class="fw-semibold text-muted" style="font-size: 12px">{{ item.label | translate }}</span>
											</div>
											<div class="card-body p-0">
												<div class="d-flex justify-content-between align-items-center p-2 border-bottom" *ngFor="let subItem of item.subItems">
													<span style="font-size: 13px">{{ subItem.label | translate }}</span>
													<div class="form-check form-switch mb-0">
														<input class="form-check-input" type="checkbox" role="switch" [checked]="getPermission(subItem.id)?.isActive == 1" (change)="togglePermission(subItem, $event)" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</ng-container>
							</ng-container>
						</div>
					</div>
				</ng-template>
			</li>

			<!-- Aqui van las otras tabs -->
		</ul>
	</div>
	<div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>

<div class="modal-footer" *ngIf="activeTabId === 1">
	<button class="btn btn-primary" type="button" (click)="updateClientUser()">Save</button>
</div>

<!-- Modals -->
<ng-template #userContractsModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Link campaign {{ selectedCampaign }} to contract</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<table class="table table-nowrap">
			<thead>
				<tr>
					<th scope="col">ID</th>
					<th scope="col">Start date</th>
					<th scope="col">End date</th>
					<th scope="col">Contract Type</th>
					<th scope="col">Pricing</th>
					<th scope="col">Action</th>
				</tr>
			</thead>
			<tbody>
				<ng-container *ngFor="let contract of contracts; let i = index">
					<tr>
						<th scope="row">
							<strong>#{{ contract.NumContract }}</strong>
						</th>
						<td>
							<span *ngIf="contract.startDate_ != '0000-00-00 00:00:00'">{{ contract.startDate_ | utcToLocal: "mediumDate" }}</span>
						</td>
						<td>
							<span *ngIf="contract.endDate_ != '0000-00-00 00:00:00'">{{ contract.endDate_ | utcToLocal: "mediumDate" }}</span>
						</td>
						<td>{{ getContractTypeName(contract.contract_type) }}</td>
						<td [ngSwitch]="contract.contract_type">
							<span *ngSwitchCase="1">Lead Cost: {{ contract.costLead | currency: "USD" }}</span>
							<span *ngSwitchCase="2">Reserve Leads: {{ contract.reserve_leads_amount }}</span>
							<span *ngSwitchCase="3">Hour Cost: {{ contract.cost_hour | currency: "USD" }}</span>
							<span *ngSwitchDefault>-</span>
						</td>
						<td>
							<a href="javascript:void(0);" class="link-success" (click)="linkContractCampaign(contract.NumContract)">Link <i class="ri-arrow-right-line align-middle"></i></a>
						</td>
					</tr>
				</ng-container>
			</tbody>
		</table>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-secondary" (click)="modal.close('Save click')">Save</button>
	</div>
</ng-template>

<ng-template #discountModal let-modal>
	<div class="modal-header">
		<h4 class="modal-title" id="modal-basic-title">Current discount: {{ credit | currency: "USD" }}</h4>
		<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
	</div>
	<div class="modal-body">
		<div class="row">
			<div class="col-2"></div>
			<div class="col-8" *ngIf="!discountLoading">
				<p>Increase or decrease the discount</p>
				<div class="input-group mb-3">
					<input type="text" [(ngModel)]="creaditAmount" class="form-control" placeholder="0.00" />
					<button class="btn btn-danger credit-btn" type="button" (click)="changeDiscount('minus')"><i class="ri-indeterminate-circle-fill"></i></button>
					<button class="btn btn-success credit-btn" type="button" (click)="changeDiscount('plus')"><i class="ri-add-circle-fill"></i></button>
				</div>
			</div>
			<div class="col-8" *ngIf="discountLoading">
				<app-loader></app-loader>
			</div>
			<div class="col-2"></div>
		</div>
	</div>
</ng-template>
